/*
 * @authors :Bin Mei
 * @description：  患者管理模块路由
 */
const route = [
  {
    path: '/hospital/editpatient/baseinfo',
    name: 'basePatientInfo',
    component: () => import(/* webpackPrefetchPlaceHolder */ './editPatient/baseInfo'),
    auth: true,
    exact: true,
    title: '基本信息添加',
  },
  {
    path: '/hospital/editpatient/extrainfo',
    name: 'extraPatientInfo',
    component: () => import(/* webpackPrefetchPlaceHolder */ './editPatient/extraInfo'),
    auth: true,
    exact: true,
    title: '问诊人信息添加',
  },
  {
    path: '/hospital/editpatient/patientfile',
    name: 'patientFile',
    component: () => import(/* webpackPrefetchPlaceHolder */ './editPatient/patientFile'),
    auth: true,
    exact: true,
    title: '健康档案录入',
  },
  // {
  //   path: '/hospital/editpatient/patienthealth',
  //   name: 'patientHealth',
  //   component: () => import(/* webpackPrefetchPlaceHolder */ './editPatient/patientHealth'),
  //   auth: true,
  //   exact: true,
  //   title: '过往病史录入',
  // },
  {
    path: '/hospital/patientdetail',
    name: 'PatientDetail',
    component: () => import(/* webpackPrefetchPlaceHolder */ './patientDetail'),
    auth: true,
    exact: true,
    title: '健康信息',
  },
  // {
  //   path: '/hospital/patienthistory',
  //   name: 'PatientHistory',
  //   component: () => import(/* webpackPrefetchPlaceHolder */ './patientsHistory'),
  //   auth: true,
  //   exact: true,
  //   title: '健康档案',
  // },
  {
    path: '/hospital/patientslist',
    name: 'PatientslList',
    component: () => import(/* webpackPrefetchPlaceHolder */ './patientsList'),
    auth: true,
    exact: true,
    title: '患者信息',
  },
  {
    path: '/hospital/patientDetail/recordList',
    name: 'patientDetailRecordList',
    component: () => import(/* webpackPrefetchPlaceHolder */ './patientDetail/recordList'),
    auth: true,
    exact: true,
    title: '问诊详情',
  },
];

export default route;
